(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(35750);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 35750:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/styles/best_sellers.module.scss
var best_sellers_module = __webpack_require__(95);
var best_sellers_module_default = /*#__PURE__*/__webpack_require__.n(best_sellers_module);
// EXTERNAL MODULE: ./src/data/home.ts
var home = __webpack_require__(44330);
// EXTERNAL MODULE: ./src/api/endpoints.ts
var endpoints = __webpack_require__(3557);
// EXTERNAL MODULE: ./src/api/http-client.ts
var http_client = __webpack_require__(55642);
// EXTERNAL MODULE: ./src/components/product-card/product-card.tsx
var product_card = __webpack_require__(91740);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/components/home/best_sellers.tsx










var Best_Sellers = function() {
    var ref = (0,react.useState)([]), data = ref[0], setData = ref[1];
    (0,react.useEffect)(function() {
        loadCustomerFavourites();
    }, []);
    var loadCustomerFavourites = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return http_client/* default.get */.Z.get(endpoints/* default.home.customerFavourites */.Z.home.customerFavourites(), {
                            params: {
                                limit: 4
                            }
                        });
                    case 2:
                        data = _ctx.sent.data;
                        setData(data);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function loadCustomerFavourites() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: !!data.length && /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: (best_sellers_module_default()).best_sellers,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (best_sellers_module_default()).best_sellersheader,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (best_sellers_module_default()).h2,
                                        children: home/* homeLinks.bestSeller.title */.n.bestSeller.title
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/customers-favourite",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (best_sellers_module_default()).btn_get_started,
                                            children: "SEE ALL Products"
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (best_sellers_module_default()).best_sellers_main,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "row",
                                children: data.slice(0, 20).map(function(v, ind) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-3",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(product_card/* default */.Z, {
                                            product: v
                                        })
                                    }, ind);
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var best_sellers = (Best_Sellers);

// EXTERNAL MODULE: ./src/image-loaders/s3-image-loader.ts
var s3_image_loader = __webpack_require__(78513);
// EXTERNAL MODULE: ./src/styles/mobile_banner.module.scss
var mobile_banner_module = __webpack_require__(70478);
var mobile_banner_module_default = /*#__PURE__*/__webpack_require__.n(mobile_banner_module);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(71911);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(30933);
// EXTERNAL MODULE: ./node_modules/swiper/modules/scrollbar/scrollbar.min.css
var scrollbar_min = __webpack_require__(13390);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 14 modules
var swiper_react = __webpack_require__(88494);
;// CONCATENATED MODULE: ./src/components/home/mobile_banner.tsx










swiper_esm/* default.use */.ZP.use([
    swiper_esm/* Navigation */.W_,
    swiper_esm/* Pagination */.tl
]);
var Mobile_Banner = function(param) {
    var banners = param.banners;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (mobile_banner_module_default()).mobile_banner_slide,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                className: "swiper-navigation ",
                navigation: true,
                spaceBetween: 0,
                slidesPerView: 1,
                pagination: {
                    clickable: true
                },
                centeredSlides: true,
                autoplay: {
                    delay: 9000,
                    disableOnInteraction: false
                },
                children: banners.filter(function(x) {
                    return x.device === "mobile";
                }).map(function(v, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (mobile_banner_module_default()).banner_images,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: v.link,
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-100",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "img-fluid",
                                        src: v.image,
                                        alt: "Home banner",
                                        width: 459,
                                        height: 461,
                                        priority: i == 0,
                                        sizes: " (max-width: 360px) 360px, (max-width: 640px) 640px, (max-width: 767px) 767px",
                                        loader: s3_image_loader/* S3ImageLoader */.V
                                    })
                                })
                            })
                        })
                    }, i);
                })
            })
        })
    });
};
/* harmony default export */ var mobile_banner = (Mobile_Banner);

// EXTERNAL MODULE: ./src/styles/mobile_best_sellers.module.scss
var mobile_best_sellers_module = __webpack_require__(73665);
var mobile_best_sellers_module_default = /*#__PURE__*/__webpack_require__.n(mobile_best_sellers_module);
;// CONCATENATED MODULE: ./src/assets/images/arrow.png
/* harmony default export */ var arrow = ({"src":"/_next/static/media/arrow.0c79f94b.png","height":15,"width":92,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAMAAADU3h9xAAAACVBMVEUAAAAAAAAAAACDY+nAAAAAA3RSTlMQBCsugFvqAAAACXBIWXMAAAsTAAALEwEAmpwYAAAADUlEQVQImWNgZAADJgAAEwAECcwkfQAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./src/components/home/mobile_best_sellers.tsx














swiper_esm/* default.use */.ZP.use([
    swiper_esm/* Navigation */.W_,
    swiper_esm/* Pagination */.tl
]);
var Mobile_Best_Sellers = function() {
    var ref = (0,react.useState)([]), data = ref[0], setData = ref[1];
    (0,react.useEffect)(function() {
        loadCustomerFavourite();
    }, []);
    var loadCustomerFavourite = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return http_client/* default.get */.Z.get(endpoints/* default.home.customerFavourites */.Z.home.customerFavourites(), {
                            params: {
                                limit: 4
                            }
                        });
                    case 2:
                        data = _ctx.sent.data;
                        setData(data);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function loadCustomerFavourite() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: !!data.length && /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: (mobile_best_sellers_module_default()).best_sellers,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container best-sellers-d",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (mobile_best_sellers_module_default()).best_sellersheader,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (mobile_best_sellers_module_default()).h2,
                                    children: home/* homeLinks.bestSeller.title */.n.bestSeller.title
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (mobile_best_sellers_module_default()).best_sellers_main,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                                className: "swiper-navigation-black",
                                navigation: true,
                                spaceBetween: 10,
                                slidesPerView: 2,
                                breakpoints: {
                                    640: {
                                        slidesPerView: 2
                                    },
                                    768: {
                                        slidesPerView: 3
                                    },
                                    1024: {
                                        slidesPerView: 4
                                    },
                                    1200: {
                                        slidesPerView: 4
                                    }
                                },
                                children: data.slice(0, 20).map(function(v, i) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (mobile_best_sellers_module_default()).jwellery,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(product_card/* default */.Z, {
                                                product: v
                                            })
                                        })
                                    }, i);
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/customers-favourite",
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (mobile_best_sellers_module_default()).btn_get_started,
                                        children: [
                                            "SEE ALL Products",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: arrow,
                                                className: "img-fluid",
                                                alt: "features10"
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var mobile_best_sellers = (Mobile_Best_Sellers);

// EXTERNAL MODULE: ./src/styles/mobile_collection.module.scss
var mobile_collection_module = __webpack_require__(88819);
var mobile_collection_module_default = /*#__PURE__*/__webpack_require__.n(mobile_collection_module);
;// CONCATENATED MODULE: ./src/components/home/mobile_collection.tsx








swiper_esm/* default.use */.ZP.use([
    swiper_esm/* Navigation */.W_,
    swiper_esm/* Pagination */.tl
]);
var Mobile_Collection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: (mobile_collection_module_default()).collection,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (mobile_collection_module_default()).collectionheader,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            children: home/* homeLinks.collection.title */.n.collection.title
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                        className: "swiper-navigation",
                        navigation: true,
                        spaceBetween: 20,
                        slidesPerView: 1,
                        breakpoints: {
                            640: {
                                slidesPerView: 2
                            },
                            768: {
                                slidesPerView: 3
                            },
                            1024: {
                                slidesPerView: 4
                            },
                            1200: {
                                slidesPerView: 4
                            }
                        },
                        children: home/* homeLinks.collection.sliders.map */.n.collection.sliders.map(function(v, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: v.link,
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (mobile_collection_module_default()).collection_slide_item,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: v.image,
                                                className: "img-fluid",
                                                alt: v.name,
                                                width: 455,
                                                height: 607
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (mobile_collection_module_default()).port_text,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (mobile_collection_module_default()).h3_sub,
                                                        children: v.name
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: "Collection"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (mobile_collection_module_default()).port_btn,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "btn-more ",
                                                    children: [
                                                        "Explore",
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: "bi bi-chevron-right text-white"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            }, i);
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var mobile_collection = (Mobile_Collection);

// EXTERNAL MODULE: ./src/styles/mobile_lustcollection.module.scss
var mobile_lustcollection_module = __webpack_require__(16300);
var mobile_lustcollection_module_default = /*#__PURE__*/__webpack_require__.n(mobile_lustcollection_module);
;// CONCATENATED MODULE: ./src/components/home/mobile_lustcollection.tsx




var Mobile_LustCollection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: "container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (mobile_lustcollection_module_default()).lustcollection,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (mobile_lustcollection_module_default()).videoResponsive,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            dangerouslySetInnerHTML: {
                                __html: home/* homeLinks.lustCollection.youtube_iframe */.n.lustCollection.youtube_iframe
                            }
                        })
                    })
                })
            })
        })
    });
};
/* harmony default export */ var mobile_lustcollection = (Mobile_LustCollection);

// EXTERNAL MODULE: ./src/styles/mobile_new_arrivals.module.scss
var mobile_new_arrivals_module = __webpack_require__(25714);
var mobile_new_arrivals_module_default = /*#__PURE__*/__webpack_require__.n(mobile_new_arrivals_module);
;// CONCATENATED MODULE: ./src/components/home/mobile_new_arrivals.tsx














swiper_esm/* default.use */.ZP.use([
    swiper_esm/* Navigation */.W_,
    swiper_esm/* Pagination */.tl
]);
var Mobile_New_Arrivals = function() {
    var ref = (0,react.useState)([]), data = ref[0], setData = ref[1];
    (0,react.useEffect)(function() {
        newArrival();
    }, []);
    var newArrival = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return http_client/* default.get */.Z.get(endpoints/* default.home.newArrival */.Z.home.newArrival());
                    case 3:
                        data = _ctx.sent.data;
                        setData(data);
                        _ctx.next = 9;
                        break;
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }));
        return function newArrival() {
            return _ref.apply(this, arguments);
        };
    }();
    if (!data.length) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: (mobile_new_arrivals_module_default()).new_arrivals,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (mobile_new_arrivals_module_default()).new_arrivalsheader,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                    children: home/* homeLinks.newArival.title */.n.newArival.title
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("fw-embed-feed", {
                            channel: "senco",
                            playlist: "5aKDPg",
                            mode: "row",
                            open_in: "default",
                            max_videos: "0",
                            placement: "middle",
                            player_placement: "bottom-right",
                            branding: "false"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (mobile_new_arrivals_module_default()).new_arrivals_main,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "row",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-12",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                                            className: "swiper-navigation-black custom_new_arrivals_mobile",
                                            navigation: true,
                                            spaceBetween: 10,
                                            slidesPerView: 2,
                                            breakpoints: {
                                                640: {
                                                    slidesPerView: 2
                                                },
                                                768: {
                                                    slidesPerView: 3
                                                },
                                                1024: {
                                                    slidesPerView: 4
                                                },
                                                1200: {
                                                    slidesPerView: 4
                                                }
                                            },
                                            children: data.slice(0, 20).map(function(product) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (mobile_new_arrivals_module_default()).jwellery,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(product_card/* default */.Z, {
                                                            product: product
                                                        })
                                                    })
                                                }, product.id);
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/new-arrivals",
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (mobile_new_arrivals_module_default()).btn_get_started,
                                        children: [
                                            "SEE ALL Products",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: arrow,
                                                className: "img-fluid",
                                                alt: "features10"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var mobile_new_arrivals = (Mobile_New_Arrivals);

// EXTERNAL MODULE: ./src/styles/mobile_perfect_gift.module.scss
var mobile_perfect_gift_module = __webpack_require__(8639);
var mobile_perfect_gift_module_default = /*#__PURE__*/__webpack_require__.n(mobile_perfect_gift_module);
;// CONCATENATED MODULE: ./src/components/home/mobile_perfect_gift.tsx








var Mobile_Perfect_Gift = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: (mobile_perfect_gift_module_default()).perfect_gift,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (mobile_perfect_gift_module_default()).perfect_gift_header,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                            children: home/* homeLinks.perfectGift.title */.n.perfectGift.title
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                        className: "swiper-navigation botted",
                        navigation: false,
                        spaceBetween: 0,
                        slidesPerView: 1,
                        autoplay: {
                            delay: 3500,
                            disableOnInteraction: false
                        },
                        pagination: {
                            clickable: false
                        },
                        grabCursor: false,
                        centeredSlides: true,
                        children: home/* homeLinks.perfectGift.images.map */.n.perfectGift.images.map(function(v, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: v.link,
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-100",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (mobile_perfect_gift_module_default()).gift_jwellery,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: v.image,
                                                    className: "img-fluid",
                                                    alt: v.name,
                                                    width: 306,
                                                    height: 468
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (mobile_perfect_gift_module_default()).gift_text,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (mobile_perfect_gift_module_default()).h3_sub,
                                                        children: v.name
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            }, i);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-center pt-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            href: home/* homeLinks.perfectGift.link */.n.perfectGift.link,
                            className: (mobile_perfect_gift_module_default()).btn_get_started,
                            children: [
                                "Explore All Gifts",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: arrow,
                                    className: "img-fluid",
                                    alt: ""
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var mobile_perfect_gift = (Mobile_Perfect_Gift);

// EXTERNAL MODULE: ./src/styles/mobile_senco_exclusive.module.scss
var mobile_senco_exclusive_module = __webpack_require__(22073);
var mobile_senco_exclusive_module_default = /*#__PURE__*/__webpack_require__.n(mobile_senco_exclusive_module);
;// CONCATENATED MODULE: ./src/components/home/mobile_senco_exclusive.tsx








swiper_esm/* default.use */.ZP.use([
    swiper_esm/* Navigation */.W_,
    swiper_esm/* Pagination */.tl
]);
var Mobile_Senco_Exclusive = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: (mobile_senco_exclusive_module_default()).senco_exclusive,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (mobile_senco_exclusive_module_default()).senco_exclusive_header,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                            className: (mobile_senco_exclusive_module_default()).senco_exclusive_header_text,
                            children: home/* homeLinks.sencoExclusive.title */.n.sencoExclusive.title
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (mobile_senco_exclusive_module_default()).senco_exclusive_main,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                            className: "swiper-navigation",
                            navigation: false,
                            spaceBetween: 10,
                            slidesPerView: 1,
                            autoplay: {
                                delay: 3500,
                                disableOnInteraction: false
                            },
                            pagination: {
                                clickable: true
                            },
                            grabCursor: true,
                            centeredSlides: true,
                            children: home/* homeLinks.sencoExclusive.images.map */.n.sencoExclusive.images.map(function(v, i) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: v.link,
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (mobile_senco_exclusive_module_default()).senco_exclusive_card,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: v.image,
                                                    alt: v.name,
                                                    width: 459,
                                                    height: 509
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (mobile_senco_exclusive_module_default()).senco_exclusive_links,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                        "aria-label": v.name,
                                                        role: "button",
                                                        className: (mobile_senco_exclusive_module_default()).btn_get_started,
                                                        children: v.name
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                }, i);
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var mobile_senco_exclusive = (Mobile_Senco_Exclusive);

// EXTERNAL MODULE: ./src/components/home/mobile_sencofiveyear.tsx
var mobile_sencofiveyear = __webpack_require__(99501);
// EXTERNAL MODULE: ./src/styles/mobile_sencostory.module.scss
var mobile_sencostory_module = __webpack_require__(17703);
var mobile_sencostory_module_default = /*#__PURE__*/__webpack_require__.n(mobile_sencostory_module);
;// CONCATENATED MODULE: ./src/components/home/mobile_sencostory.tsx






var Mobile_SencoStory = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (mobile_sencostory_module_default()).sencostory,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: home/* homeLinks.store.image */.n.store.image,
                            alt: "",
                            width: 515,
                            height: 634
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (mobile_sencostory_module_default()).sencostory_main,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "container",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "row",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "col-md-6",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (mobile_sencostory_module_default()).h2,
                                                children: home/* homeLinks.store.title */.n.store.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: home/* homeLinks.store.link */.n.store.link,
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (mobile_sencostory_module_default()).btn_get_started,
                                                    children: "LOCATE STORE"
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (mobile_sencostory_module_default()).history,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (mobile_sencostory_module_default()).h4,
                                children: "The Senco Story"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                dangerouslySetInnerHTML: {
                                    __html: home/* homeLinks.store.story */.n.store.story
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: home/* homeLinks.store.story_link */.n.store.story_link,
                                passHref: true,
                                children: "Know More..."
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var mobile_sencostory = (Mobile_SencoStory);

// EXTERNAL MODULE: ./src/styles/mobile_shop_by_category.module.scss
var mobile_shop_by_category_module = __webpack_require__(70320);
var mobile_shop_by_category_module_default = /*#__PURE__*/__webpack_require__.n(mobile_shop_by_category_module);
;// CONCATENATED MODULE: ./src/components/home/mobile_shop_by_category.tsx


// Import Swiper styles








swiper_esm/* default.use */.ZP.use([
    swiper_esm/* Navigation */.W_,
    swiper_esm/* Pagination */.tl
]);
var Mobile_Shop_By_Category = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (mobile_shop_by_category_module_default()).mobile_shop_by_category,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: (mobile_shop_by_category_module_default()).shopbycategoryheader_head,
                        children: home/* homeLinks.shopByCategory.title */.n.shopByCategory.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (mobile_shop_by_category_module_default()).mobile_shop_by_category_slider,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                                className: "swiper-navigation-black pb-4",
                                spaceBetween: 0,
                                slidesPerView: 2,
                                pagination: false,
                                navigation: {
                                    prevEl: ".swiper-button-prev-1",
                                    nextEl: ".swiper-button-next-1"
                                },
                                modules: [
                                    swiper_esm/* Pagination */.tl,
                                    swiper_esm/* Navigation */.W_
                                ],
                                centeredSlides: false,
                                breakpoints: {
                                    1199: {
                                        slidesPerView: 6
                                    }
                                },
                                children: home/* homeLinks.shopByCategory.sliders.map */.n.shopByCategory.sliders.map(function(v, i) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (mobile_shop_by_category_module_default()).mobile_shop_by_category_card,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: v.link,
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "w-100",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            src: v.image,
                                                            alt: "Shop by Category",
                                                            width: 134,
                                                            height: 140
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: v.name
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    }, i);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((mobile_shop_by_category_module_default()).swiper_button_prev_1, " ", "swiper-button-prev-1 bi bi-arrow-left-circle")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((mobile_shop_by_category_module_default()).swiper_button_next_1, " ", "swiper-button-next-1 bi bi-arrow-right-circle")
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var mobile_shop_by_category = (Mobile_Shop_By_Category);

// EXTERNAL MODULE: ./src/styles/mobile_shopbybudget.module.scss
var mobile_shopbybudget_module = __webpack_require__(2927);
var mobile_shopbybudget_module_default = /*#__PURE__*/__webpack_require__.n(mobile_shopbybudget_module);
;// CONCATENATED MODULE: ./src/components/home/mobile_shopbybudget.tsx


// Import Swiper styles







swiper_esm/* default.use */.ZP.use([
    swiper_esm/* Navigation */.W_,
    swiper_esm/* Pagination */.tl
]);
var Mobile_Shopbybudget = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (mobile_shopbybudget_module_default()).mobile_shopbybudget,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (mobile_shopbybudget_module_default()).shopbybudgetheader,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: (mobile_shopbybudget_module_default()).shopbybudgetheader_text,
                            children: home/* homeLinks.shopByBudget.title */.n.shopByBudget.title
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (mobile_shopbybudget_module_default()).row,
                        children: home/* homeLinks.shopByBudget.images.map */.n.shopByBudget.images.map(function(v, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (mobile_shopbybudget_module_default()).col_6,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: v.link,
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "portfolio-wrap text-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: v.image,
                                                className: "img-fluid",
                                                alt: "Shop by Budget",
                                                width: 237,
                                                height: 224
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (mobile_shopbybudget_module_default()).h5,
                                                children: v.price
                                            })
                                        ]
                                    })
                                })
                            }, i);
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var mobile_shopbybudget = (Mobile_Shopbybudget);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/styles/mobile_subscribe.module.scss
var mobile_subscribe_module = __webpack_require__(65014);
var mobile_subscribe_module_default = /*#__PURE__*/__webpack_require__.n(mobile_subscribe_module);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82175);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.js + 1 modules
var react_toastify_esm = __webpack_require__(40782);
;// CONCATENATED MODULE: ./src/components/home/mobile_subscribe.tsx












var Mobile_Subscribe = function() {
    var formik = (0,formik_esm/* useFormik */.TA)({
        initialValues: {
            email: ""
        },
        validationSchema: es/* object */.Ry({
            email: es/* string */.Z_().email("Invalid email format")
        }),
        onSubmit: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values, param) {
                var resetForm, data, ref, ref1;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            resetForm = param.resetForm;
                            if (!values.email.length) {
                                _ctx.next = 14;
                                break;
                            }
                            _ctx.prev = 2;
                            _ctx.next = 5;
                            return http_client/* default.post */.Z.post(endpoints/* default.auth.subscribe */.Z.auth.subscribe(), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, values), {
                                type: "senco_website"
                            }));
                        case 5:
                            data = _ctx.sent.data;
                            (0,react_toastify_esm/* toast */.Am)(data.message, {
                                type: "success"
                            });
                            resetForm();
                            _ctx.next = 14;
                            break;
                        case 10:
                            _ctx.prev = 10;
                            _ctx.t0 = _ctx["catch"](2);
                            ;
                            if ((ref = _ctx.t0.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message) {
                                (0,react_toastify_esm/* toast */.Am)(_ctx.t0.response.data.message, {
                                    type: "error"
                                });
                            } else {
                                (0,react_toastify_esm/* toast */.Am)("Something went wrong! Try again!", {
                                    type: "error"
                                });
                            }
                        case 14:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        2,
                        10
                    ]
                ]);
            }));
            return function(values, _) {
                return _ref.apply(this, arguments);
            };
        }()
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: (mobile_subscribe_module_default()).subscribe_main_full,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (mobile_subscribe_module_default()).subscribe_main,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row mt-3 pb-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "middle-section",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (mobile_subscribe_module_default()).h4,
                                            children: [
                                                "Stay ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: " in touch"
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                " & get latest",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                " updates and offers",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                "and design"
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                        className: "mt-0 pt-2",
                                        action: "",
                                        onSubmit: formik.handleSubmit,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "row",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                                        className: (mobile_subscribe_module_default()).form_input,
                                                        type: "email",
                                                        placeholder: "YOUR EMAIL"
                                                    }, formik.getFieldProps("email"))),
                                                    formik.errors.email ? /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                        className: "text-white",
                                                        children: formik.errors.email
                                                    }) : null
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                role: "button",
                                                "aria-label": "SUBSCRIBE",
                                                className: (mobile_subscribe_module_default()).btn_get_started1,
                                                type: "submit",
                                                children: [
                                                    "SUBSCRIBE ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: "bi bi-arrow-right"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {})
                ]
            })
        })
    });
};
/* harmony default export */ var mobile_subscribe = (Mobile_Subscribe);

// EXTERNAL MODULE: ./src/styles/mobile_trending_design.module.scss
var mobile_trending_design_module = __webpack_require__(82409);
var mobile_trending_design_module_default = /*#__PURE__*/__webpack_require__.n(mobile_trending_design_module);
;// CONCATENATED MODULE: ./src/components/home/mobile_trending_design.tsx











swiper_esm/* default.use */.ZP.use([
    swiper_esm/* Navigation */.W_,
    swiper_esm/* Pagination */.tl
]);
var Mobile_Trending_Design = function() {
    var ref = (0,react.useState)([]), data = ref[0], setData = ref[1];
    (0,react.useEffect)(function() {
        trendingDesign();
    }, []);
    var trendingDesign = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var value, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        value = {
                            slugs: JSON.parse(localStorage.getItem("recentViews") || "[]")
                        };
                        _ctx.next = 3;
                        return http_client/* default.post */.Z.post(endpoints/* default.home.trendingDesign */.Z.home.trendingDesign(), value);
                    case 3:
                        data = _ctx.sent.data;
                        setData(data);
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function trendingDesign() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: !!data.length && /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: (mobile_trending_design_module_default()).trending_design,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (mobile_trending_design_module_default()).trending_design_header,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (mobile_trending_design_module_default()).h2,
                                    children: home/* homeLinks.trendingDesign.title */.n.trendingDesign.title
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (mobile_trending_design_module_default()).trending_design_main,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                                className: "swiper-navigation-black",
                                navigation: true,
                                spaceBetween: 10,
                                slidesPerView: 2,
                                breakpoints: {
                                    640: {
                                        slidesPerView: 2
                                    },
                                    768: {
                                        slidesPerView: 3
                                    },
                                    1024: {
                                        slidesPerView: 4
                                    },
                                    1200: {
                                        slidesPerView: 4
                                    }
                                },
                                children: data.map(function(product) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (mobile_trending_design_module_default()).trend,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(product_card/* default */.Z, {
                                                product: product
                                            })
                                        })
                                    }, product.id);
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var mobile_trending_design = (Mobile_Trending_Design);

// EXTERNAL MODULE: ./src/styles/mobile_vivah_collection.module.scss
var mobile_vivah_collection_module = __webpack_require__(73303);
var mobile_vivah_collection_module_default = /*#__PURE__*/__webpack_require__.n(mobile_vivah_collection_module);
// EXTERNAL MODULE: ./node_modules/react-lite-youtube-embed/dist/index.es.js
var index_es = __webpack_require__(54208);
;// CONCATENATED MODULE: ./src/components/home/mobile_vivah_collection.tsx









var Mobile_Vivah_Collection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (mobile_vivah_collection_module_default()).vivah_collection,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: " container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (mobile_vivah_collection_module_default()).vivah_collection_header,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (mobile_vivah_collection_module_default()).vivah_collection_header_text,
                                children: home/* homeLinks.vivahCollection.title */.n.vivahCollection.title
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (mobile_vivah_collection_module_default()).vivah_collection_main,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (mobile_vivah_collection_module_default()).videoResponsive,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "row",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.Z, {
                                            id: home/* homeLinks.vivahCollection.youtube_iframe_id */.n.vivahCollection.youtube_iframe_id,
                                            title: "Vivah Collection",
                                            webp: true,
                                            noCookie: true,
                                            poster: "maxresdefault"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, {
                                    className: "swiper-navigation",
                                    navigation: true,
                                    spaceBetween: 20,
                                    slidesPerView: 1,
                                    breakpoints: {
                                        640: {
                                            slidesPerView: 2
                                        },
                                        768: {
                                            slidesPerView: 3
                                        },
                                        1024: {
                                            slidesPerView: 4
                                        },
                                        1200: {
                                            slidesPerView: 4
                                        }
                                    },
                                    children: [
                                        home/* homeLinks.vivahCollection.images.map */.n.vivahCollection.images.map(function(v, i) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: v.link,
                                                    passHref: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (mobile_vivah_collection_module_default()).vivah_collection_card_1,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            src: v.image,
                                                            alt: "vivaha collection",
                                                            width: 261,
                                                            height: 347
                                                        })
                                                    })
                                                })
                                            }, i);
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                            children: "4"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: home/* homeLinks.vivahCollection.link */.n.vivahCollection.link,
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (mobile_vivah_collection_module_default()).btn_get_started,
                                    children: [
                                        "EXPLOER",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: arrow,
                                            className: "img-fluid",
                                            alt: "EXPLOER"
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var mobile_vivah_collection = (Mobile_Vivah_Collection);

// EXTERNAL MODULE: ./src/assets/images/prodd3.png
var prodd3 = __webpack_require__(56668);
// EXTERNAL MODULE: ./src/assets/images/prodd4.png
var prodd4 = __webpack_require__(55824);
// EXTERNAL MODULE: ./src/assets/images/prodd5.png
var prodd5 = __webpack_require__(11087);
// EXTERNAL MODULE: ./src/assets/images/prodd6.png
var prodd6 = __webpack_require__(37018);
// EXTERNAL MODULE: ./src/assets/images/prodd7.png
var prodd7 = __webpack_require__(27820);
// EXTERNAL MODULE: ./src/assets/images/prodd8.png
var prodd8 = __webpack_require__(55603);
// EXTERNAL MODULE: ./src/styles/mobile_with_every_product.module.scss
var mobile_with_every_product_module = __webpack_require__(20337);
var mobile_with_every_product_module_default = /*#__PURE__*/__webpack_require__.n(mobile_with_every_product_module);
;// CONCATENATED MODULE: ./src/components/home/mobile_with_every_product.tsx










var Mobile_With_Every_Product = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (mobile_with_every_product_module_default()).with_every_product,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row d-flex justify-content-center mt-0 border_bottom_1 pb-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (mobile_with_every_product_module_default()).col_14,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (mobile_with_every_product_module_default()).with_icon,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: prodd3/* default */.Z,
                                            alt: "Zero Deduction Gold Exchange",
                                            className: "img-fluid"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "Zero Deduction Gold Exchange"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (mobile_with_every_product_module_default()).col_14,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (mobile_with_every_product_module_default()).with_icon,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: prodd3/* default */.Z,
                                            alt: "Easy Exchange",
                                            className: "img-fluid"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "Easy Exchange"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (mobile_with_every_product_module_default()).col_14,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (mobile_with_every_product_module_default()).with_icon,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: prodd4/* default */.Z,
                                            alt: "Assured Lifetime Maintenance",
                                            className: "img-fluid"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "Assured Lifetime Maintenance"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (mobile_with_every_product_module_default()).col_14,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (mobile_with_every_product_module_default()).with_icon,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: prodd5/* default */.Z,
                                            alt: "Tested & Certified Diamonds",
                                            className: "img-fluid"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "Tested & Certified Diamonds"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (mobile_with_every_product_module_default()).col_14,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (mobile_with_every_product_module_default()).with_icon,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: prodd6/* default */.Z,
                                            alt: "BIS Hallmarked Pure Gold",
                                            className: "img-fluid"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "BIS Hallmarked Pure Gold"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (mobile_with_every_product_module_default()).col_14,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (mobile_with_every_product_module_default()).with_icon,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: prodd7/* default */.Z,
                                            alt: "Guaranteed Buyback",
                                            className: "img-fluid"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "Guaranteed Buyback"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (mobile_with_every_product_module_default()).col_14,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (mobile_with_every_product_module_default()).with_icon,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: prodd8/* default */.Z,
                                            alt: "7 Days Retun Policy",
                                            className: "img-fluid"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "7 Days Retun Policy"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var mobile_with_every_product = (Mobile_With_Every_Product);

// EXTERNAL MODULE: ./src/styles/senco_exclusive.module.scss
var senco_exclusive_module = __webpack_require__(2954);
var senco_exclusive_module_default = /*#__PURE__*/__webpack_require__.n(senco_exclusive_module);
;// CONCATENATED MODULE: ./src/components/home/senco_exclusive.tsx







swiper_esm/* default.use */.ZP.use([
    swiper_esm/* Navigation */.W_,
    swiper_esm/* Pagination */.tl
]);
var senco_exclusive = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: (senco_exclusive_module_default()).senco_exclusive,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (senco_exclusive_module_default()).senco_exclusive_header,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                            className: (senco_exclusive_module_default()).senco_exclusive_header_text,
                            children: home/* homeLinks.sencoExclusive.title */.n.sencoExclusive.title
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (senco_exclusive_module_default()).senco_exclusive_main,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row",
                            children: home/* homeLinks.sencoExclusive.images.map */.n.sencoExclusive.images.map(function(v, i) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-4",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: v.link,
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (senco_exclusive_module_default()).senco_exclusive_card,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: v.image,
                                                    alt: v.name,
                                                    width: 356,
                                                    height: 452
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (senco_exclusive_module_default()).senco_exclusive_links,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                        role: "button",
                                                        className: (senco_exclusive_module_default()).btn_get_started,
                                                        children: v.name
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                }, i);
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var home_senco_exclusive = (senco_exclusive);

// EXTERNAL MODULE: ./src/components/home/sencofiveyear.tsx
var sencofiveyear = __webpack_require__(38822);
;// CONCATENATED MODULE: ./src/assets/images/arrow2.png
/* harmony default export */ var arrow2 = ({"src":"/_next/static/media/arrow2.b1dd1a62.png","height":12,"width":108,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAMAAADU3h9xAAAABlBMVEX+Ijv7LUWJ2bGjAAAACXBIWXMAAAsTAAALEwEAmpwYAAAADElEQVQImWNggABGAAAKAALh+ummAAAAAElFTkSuQmCC"});
// EXTERNAL MODULE: ./src/styles/mobile_senco_story.module.scss
var mobile_senco_story_module = __webpack_require__(3670);
var mobile_senco_story_module_default = /*#__PURE__*/__webpack_require__.n(mobile_senco_story_module);
;// CONCATENATED MODULE: ./src/components/home/sencostory.tsx







var SencoStory = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (mobile_senco_story_module_default()).sencostory,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: home/* homeLinks.store.image */.n.store.image,
                            alt: "",
                            width: 1337,
                            height: 550
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (mobile_senco_story_module_default()).sencostory_main,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "container",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "row",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "col-md-6",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                children: home/* homeLinks.store.title */.n.store.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: home/* homeLinks.store.link */.n.store.link,
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (mobile_senco_story_module_default()).btn_get_started,
                                                    children: [
                                                        "LOCATE STORE ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            src: arrow2,
                                                            alt: "LOCATE STORE"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (mobile_senco_story_module_default()).history,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: "The Senco Story"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                dangerouslySetInnerHTML: {
                                    __html: home/* homeLinks.store.story */.n.store.story
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: home/* homeLinks.store.story_link */.n.store.story_link,
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: "Know More..."
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var sencostory = (SencoStory);

// EXTERNAL MODULE: ./src/styles/subscribe.module.scss
var subscribe_module = __webpack_require__(31637);
var subscribe_module_default = /*#__PURE__*/__webpack_require__.n(subscribe_module);
;// CONCATENATED MODULE: ./src/components/home/subscribe.tsx












var Subscribe = function() {
    var formik = (0,formik_esm/* useFormik */.TA)({
        initialValues: {
            email: ""
        },
        validationSchema: es/* object */.Ry({
            email: es/* string */.Z_().email("Invalid email format")
        }),
        onSubmit: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values, param) {
                var resetForm, data, ref, ref1;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            resetForm = param.resetForm;
                            if (!values.email.length) {
                                _ctx.next = 14;
                                break;
                            }
                            _ctx.prev = 2;
                            _ctx.next = 5;
                            return http_client/* default.post */.Z.post(endpoints/* default.auth.subscribe */.Z.auth.subscribe(), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, values), {
                                type: "senco_website"
                            }));
                        case 5:
                            data = _ctx.sent.data;
                            (0,react_toastify_esm/* toast */.Am)(data.message, {
                                type: "success"
                            });
                            resetForm();
                            _ctx.next = 14;
                            break;
                        case 10:
                            _ctx.prev = 10;
                            _ctx.t0 = _ctx["catch"](2);
                            ;
                            if ((ref = _ctx.t0.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message) {
                                (0,react_toastify_esm/* toast */.Am)(_ctx.t0.response.data.message, {
                                    type: "error"
                                });
                            } else {
                                (0,react_toastify_esm/* toast */.Am)("Something went wrong! Try again!", {
                                    type: "error"
                                });
                            }
                        case 14:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        2,
                        10
                    ]
                ]);
            }));
            return function(values, _) {
                return _ref.apply(this, arguments);
            };
        }()
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (subscribe_module_default()).subscribe_main,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row mt-3 pb-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "middle-section",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (subscribe_module_default()).h4,
                                            children: [
                                                "Stay ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: " in touch"
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                " & get latest",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                " updates and offers",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                "and design"
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                        className: "mt-5 pt-5",
                                        onSubmit: formik.handleSubmit,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "row",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                                        className: (subscribe_module_default()).form_input,
                                                        type: "email",
                                                        placeholder: "YOUR EMAIL"
                                                    }, formik.getFieldProps("email"))),
                                                    formik.errors.email ? /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                        className: "text-white",
                                                        children: formik.errors.email
                                                    }) : null
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                role: "button",
                                                "aria-label": "SUBSCRIBE",
                                                className: (subscribe_module_default()).btn_get_started1,
                                                type: "submit",
                                                children: [
                                                    "SUBSCRIBE ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: "bi bi-arrow-right"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {})
                ]
            })
        })
    });
};
/* harmony default export */ var subscribe = (Subscribe);

// EXTERNAL MODULE: ./src/components/home/trending_design.tsx
var trending_design = __webpack_require__(75908);
// EXTERNAL MODULE: ./src/styles/vivah_collection.module.scss
var vivah_collection_module = __webpack_require__(80739);
var vivah_collection_module_default = /*#__PURE__*/__webpack_require__.n(vivah_collection_module);
;// CONCATENATED MODULE: ./src/components/home/vivah_collection.tsx








var Vivah_Collection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (vivah_collection_module_default()).vivah_collection,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: " container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (vivah_collection_module_default()).vivah_collection_header,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (vivah_collection_module_default()).vivah_collection_header_text,
                                children: home/* homeLinks.vivahCollection.title */.n.vivahCollection.title
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (vivah_collection_module_default()).vivah_collection_main,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (vivah_collection_module_default()).videoResponsive,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "row",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.Z, {
                                            id: home/* homeLinks.vivahCollection.youtube_iframe_id */.n.vivahCollection.youtube_iframe_id,
                                            title: "Vivah Collection",
                                            webp: true,
                                            noCookie: true,
                                            poster: "maxresdefault"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                                    className: "swiper-navigation",
                                    navigation: true,
                                    spaceBetween: 20,
                                    slidesPerView: 1,
                                    breakpoints: {
                                        640: {
                                            slidesPerView: 2
                                        },
                                        768: {
                                            slidesPerView: 3
                                        },
                                        1024: {
                                            slidesPerView: 4
                                        },
                                        1200: {
                                            slidesPerView: 4
                                        }
                                    },
                                    children: home/* homeLinks.vivahCollection.images.map */.n.vivahCollection.images.map(function(v, i) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: v.link,
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (vivah_collection_module_default()).vivah_collection_card_1,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: v.image,
                                                        alt: "vivaha collection",
                                                        width: 261,
                                                        height: 347
                                                    })
                                                })
                                            })
                                        }, i);
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: home/* homeLinks.vivahCollection.link */.n.vivahCollection.link,
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (vivah_collection_module_default()).btn_get_started,
                                    children: "Shop now"
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var vivah_collection = (Vivah_Collection);

// EXTERNAL MODULE: ./src/assets/images/prodd2.png
var prodd2 = __webpack_require__(77492);
// EXTERNAL MODULE: ./src/styles/with_every_product.module.scss
var with_every_product_module = __webpack_require__(11329);
var with_every_product_module_default = /*#__PURE__*/__webpack_require__.n(with_every_product_module);
;// CONCATENATED MODULE: ./src/components/home/with_every_product.tsx











var With_Every_Product = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (with_every_product_module_default()).with_every_product,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (with_every_product_module_default()).h2,
                            children: "With every product you buy you get"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row d-flex justify-content-center mt-5 border_bottom_1 pb-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (with_every_product_module_default()).col_14,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (with_every_product_module_default()).with_icon,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: prodd2/* default */.Z,
                                                alt: "Zero Deduction Gold Exchange",
                                                className: "img-fluid"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Zero Deduction Gold Exchange"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (with_every_product_module_default()).col_14,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (with_every_product_module_default()).with_icon,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: prodd3/* default */.Z,
                                                alt: "Easy Exchange",
                                                className: "img-fluid"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Easy Exchange"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (with_every_product_module_default()).col_14,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (with_every_product_module_default()).with_icon,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: prodd4/* default */.Z,
                                                alt: "Assured Lifetime Maintenance",
                                                className: "img-fluid"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Assured Lifetime Maintenance"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (with_every_product_module_default()).col_14,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (with_every_product_module_default()).with_icon,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: prodd5/* default */.Z,
                                                alt: "Tested & Certified Diamonds",
                                                className: "img-fluid"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Tested & Certified Diamonds"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (with_every_product_module_default()).col_14,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (with_every_product_module_default()).with_icon,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: prodd6/* default */.Z,
                                                alt: "BIS Hallmarked Pure Gold",
                                                className: "img-fluid"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "BIS Hallmarked Pure Gold"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (with_every_product_module_default()).col_14,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (with_every_product_module_default()).with_icon,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: prodd7/* default */.Z,
                                                alt: "Guaranteed Buyback",
                                                className: "img-fluid"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Guaranteed Buyback"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (with_every_product_module_default()).col_14,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (with_every_product_module_default()).with_icon,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: prodd8/* default */.Z,
                                                alt: "7 Days Return Policy",
                                                className: "img-fluid"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "7 Days Return Policy"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var with_every_product = (With_Every_Product);

// EXTERNAL MODULE: ./src/styles/homeloader.module.scss
var homeloader_module = __webpack_require__(22828);
var homeloader_module_default = /*#__PURE__*/__webpack_require__.n(homeloader_module);
;// CONCATENATED MODULE: ./src/assets/images/heart.png
/* harmony default export */ var heart = ({"src":"/_next/static/media/heart.fae68827.png","height":64,"width":64,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAJFBMVEX5WV75WV/5WV74WF74WF75WF74WF75WV74WV74WV/5WV/5WF5u83e4AAAAC3RSTlMBF2L3n9JRgMzX1/L4x+UAAAAJcEhZcwAAAdgAAAHYAfpcpnIAAAAySURBVAiZPcq5DcAwDMBASvLP/fcNYgS5hg3hN1fmmjC8BmlpmdCtsgNxdMd7R2u3nwcoqgECM4VNaQAAAABJRU5ErkJggg=="});
// EXTERNAL MODULE: ./src/layout/layout.tsx + 18 modules
var layout = __webpack_require__(70081);
// EXTERNAL MODULE: ./src/styles/slider.module.scss
var slider_module = __webpack_require__(51317);
var slider_module_default = /*#__PURE__*/__webpack_require__.n(slider_module);
;// CONCATENATED MODULE: ./src/components/home/hero.tsx








swiper_esm/* default.use */.ZP.use([
    swiper_esm/* Navigation */.W_,
    swiper_esm/* Pagination */.tl,
    swiper_esm/* Autoplay */.pt
]);
var Hero = function(param) {
    var banners = param.banners;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: "banner_main",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (slider_module_default()).banner_main_slide,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                    className: "swiper-navigation swiper-dotted",
                    navigation: true,
                    spaceBetween: 0,
                    slidesPerView: 1,
                    pagination: {
                        clickable: true
                    },
                    centeredSlides: true,
                    autoplay: {
                        delay: 9000,
                        disableOnInteraction: false
                    },
                    children: banners.filter(function(x) {
                        return x.device === "desktop";
                    }).map(function(v, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (slider_module_default()).banner_main,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: v.link,
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-100",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: v.image,
                                            width: 1900,
                                            height: 430,
                                            alt: "Home banner",
                                            priority: i == 0,
                                            sizes: " (max-width: 768px) 768px, (max-width: 1400px) 1400px,(max-width: 1600px) 1600px, (max-width: 1920px) 1920px",
                                            loader: s3_image_loader/* S3ImageLoader */.V
                                        })
                                    })
                                })
                            })
                        }, i);
                    })
                })
            })
        })
    });
};
/* harmony default export */ var hero = (Hero);

// EXTERNAL MODULE: ./src/lib/syte.ts
var syte = __webpack_require__(68320);
// EXTERNAL MODULE: ./src/store/slices/auth.ts
var auth = __webpack_require__(40034);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var react_redux_es = __webpack_require__(9473);
;// CONCATENATED MODULE: ./src/pages/index.tsx



































var ExpressDeliveryComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 607).then(__webpack_require__.bind(__webpack_require__, 80607));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80607)
            ];
        }
    }
});
var OtherProductsComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2468).then(__webpack_require__.bind(__webpack_require__, 12468));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(12468)
            ];
        }
    }
});
var ShopByCategoryComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6766).then(__webpack_require__.bind(__webpack_require__, 76766));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(76766)
            ];
        }
    }
});
var ShopByBudgetComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9092).then(__webpack_require__.bind(__webpack_require__, 59092));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(59092)
            ];
        }
    }
});
var CollectionComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6066), __webpack_require__.e(1127)]).then(__webpack_require__.bind(__webpack_require__, 71127));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(71127)
            ];
        }
    }
});
var LustCollectionComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1742).then(__webpack_require__.bind(__webpack_require__, 91742));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(91742)
            ];
        }
    }
});
var PerfectGiftComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5309).then(__webpack_require__.bind(__webpack_require__, 55309));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(55309)
            ];
        }
    }
});
var NewArrivalsComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3188).then(__webpack_require__.bind(__webpack_require__, 63188));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(63188)
            ];
        }
    }
});
var Home = function(param) {
    var isMobile = param.isMobile, banners = param.banners;
    var ref;
    var authState = (0,react_redux_es/* useSelector */.v9)(auth/* selectAuth */.Hz);
    var ref1 = (0,react.useState)(false), isVisible = ref1[0], setIsVisible = ref1[1];
    (0,react.useEffect)(function() {
        var timer = setTimeout(function() {
            setIsVisible(false);
        }, 60000); // 30 seconds
        return function() {
            return clearTimeout(timer);
        };
    }, []);
    (0,react.useEffect)(function() {
        if (!authState.isUserLoading) {
            var ref;
            (0,syte/* syteTrackEvent */.l)({
                name: "fe_page_view",
                tag: "ecommerce",
                osh_id: (ref = authState.user) === null || ref === void 0 ? void 0 : ref.uuid
            });
        }
    }, [
        authState.isUserLoading,
        (ref = authState.user) === null || ref === void 0 ? void 0 : ref.uuid
    ]);
    // useEffect(() => {
    //   if (typeof window === "undefined") return;
    //   if (!isVisible) return;
    //   const anyWindow = window as any;
    //   if (
    //     !anyWindow.tsParticles ||
    //     typeof anyWindow.tsParticles.load !== "function"
    //   )
    //     return;
    //   anyWindow.tsParticles.load("tsparticles", {
    //     background: {
    //       color: "transparent",
    //     },
    //     particles: {
    //       color: { value: "#ffffff" },
    //       move: {
    //         direction: "bottom",
    //         enable: true,
    //         outModes: "out",
    //         speed: 2,
    //       },
    //       number: {
    //         density: {
    //           enable: true,
    //           area: 800,
    //         },
    //         value: 350,
    //       },
    //       opacity: {
    //         value: 0.7,
    //       },
    //       shape: {
    //         type: "circle",
    //       },
    //       size: {
    //         value: 5,
    //       },
    //       wobble: {
    //         enable: true,
    //         distance: 10,
    //         speed: 10,
    //       },
    //       zIndex: {
    //         value: { min: 0, max: 100 },
    //       },
    //     },
    //   });
    // }, [isVisible]);
    if (isMobile) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                isVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (homeloader_module_default()).homepage_diamond_rain,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (homeloader_module_default()).snowflakes,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (homeloader_module_default()).snowflake,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: heart,
                                    alt: "diamond",
                                    className: "img-fluid"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (homeloader_module_default()).snowflake,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: heart,
                                    alt: "diamond",
                                    className: "img-fluid"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (homeloader_module_default()).snowflake,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: heart,
                                    alt: "diamond",
                                    className: "img-fluid"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (homeloader_module_default()).snowflake,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: heart,
                                    alt: "diamond",
                                    className: "img-fluid"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (homeloader_module_default()).snowflake,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: heart,
                                    alt: "diamond",
                                    className: "img-fluid"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (homeloader_module_default()).snowflake,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: heart,
                                    alt: "diamond",
                                    className: "img-fluid"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (homeloader_module_default()).snowflake,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: heart,
                                    alt: "diamond",
                                    className: "img-fluid"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (homeloader_module_default()).snowflake,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: heart,
                                    alt: "diamond",
                                    className: "img-fluid"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (homeloader_module_default()).snowflake,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: heart,
                                    alt: "diamond",
                                    className: "img-fluid"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (homeloader_module_default()).snowflake,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: heart,
                                    alt: "diamond",
                                    className: "img-fluid"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (homeloader_module_default()).snowflake,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: heart,
                                    alt: "diamond",
                                    className: "img-fluid"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (homeloader_module_default()).snowflake,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: heart,
                                    alt: "diamond",
                                    className: "img-fluid"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (homeloader_module_default()).snowflake,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: heart,
                                    alt: "diamond",
                                    className: "img-fluid"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (homeloader_module_default()).snowflake,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: heart,
                                    alt: "diamond",
                                    className: "img-fluid"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (homeloader_module_default()).snowflake,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: heart,
                                    alt: "diamond",
                                    className: "img-fluid"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (homeloader_module_default()).snowflake,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: heart,
                                    alt: "diamond",
                                    className: "img-fluid"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (homeloader_module_default()).snowflake,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: heart,
                                    alt: "diamond",
                                    className: "img-fluid"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (homeloader_module_default()).snowflake,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: heart,
                                    alt: "diamond",
                                    className: "img-fluid"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (homeloader_module_default()).snowflake,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: heart,
                                    alt: "diamond",
                                    className: "img-fluid"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (homeloader_module_default()).snowflake,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: heart,
                                    alt: "diamond",
                                    className: "img-fluid"
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_banner, {
                    banners: banners
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_shop_by_category, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_shopbybudget, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_collection, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_lustcollection, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_perfect_gift, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_new_arrivals, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_senco_exclusive, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_best_sellers, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_trending_design, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_vivah_collection, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_sencofiveyear/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_with_every_product, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_subscribe, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_sencostory, {})
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isVisible && // <div id="tsparticles"></div>
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (homeloader_module_default()).homepage_diamond_rain,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (homeloader_module_default()).snowflakes,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (homeloader_module_default()).snowflake,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: heart,
                                alt: "diamond",
                                className: "img-fluid"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (homeloader_module_default()).snowflake,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: heart,
                                alt: "diamond",
                                className: "img-fluid"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (homeloader_module_default()).snowflake,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: heart,
                                alt: "diamond",
                                className: "img-fluid"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (homeloader_module_default()).snowflake,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: heart,
                                alt: "diamond",
                                className: "img-fluid"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (homeloader_module_default()).snowflake,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: heart,
                                alt: "diamond",
                                className: "img-fluid"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (homeloader_module_default()).snowflake,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: heart,
                                alt: "diamond",
                                className: "img-fluid"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (homeloader_module_default()).snowflake,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: heart,
                                alt: "diamond",
                                className: "img-fluid"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (homeloader_module_default()).snowflake,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: heart,
                                alt: "diamond",
                                className: "img-fluid"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (homeloader_module_default()).snowflake,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: heart,
                                alt: "diamond",
                                className: "img-fluid"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (homeloader_module_default()).snowflake,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: heart,
                                alt: "diamond",
                                className: "img-fluid"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (homeloader_module_default()).snowflake,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: heart,
                                alt: "diamond",
                                className: "img-fluid"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (homeloader_module_default()).snowflake,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: heart,
                                alt: "diamond",
                                className: "img-fluid"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (homeloader_module_default()).snowflake,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: heart,
                                alt: "diamond",
                                className: "img-fluid"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (homeloader_module_default()).snowflake,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: heart,
                                alt: "diamond",
                                className: "img-fluid"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (homeloader_module_default()).snowflake,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: heart,
                                alt: "diamond",
                                className: "img-fluid"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (homeloader_module_default()).snowflake,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: heart,
                                alt: "diamond",
                                className: "img-fluid"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (homeloader_module_default()).snowflake,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: heart,
                                alt: "diamond",
                                className: "img-fluid"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (homeloader_module_default()).snowflake,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: heart,
                                alt: "diamond",
                                className: "img-fluid"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (homeloader_module_default()).snowflake,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: heart,
                                alt: "diamond",
                                className: "img-fluid"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (homeloader_module_default()).snowflake,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: heart,
                                alt: "diamond",
                                className: "img-fluid"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(hero, {
                banners: banners
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopByCategoryComponent, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopByBudgetComponent, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionComponent, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LustCollectionComponent, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PerfectGiftComponent, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewArrivalsComponent, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(home_senco_exclusive, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(best_sellers, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(trending_design/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(vivah_collection, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sencofiveyear/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(with_every_product, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(subscribe, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sencostory, {})
        ]
    });
};
Home.getLayout = function(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* default */.Z, {
        children: page
    });
};
var __N_SSP = true;
/* harmony default export */ var pages = (Home);


/***/ }),

/***/ 95:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"best_sellers":"best_sellers_best_sellers__d1bN_","best_sellersheader":"best_sellers_best_sellersheader__UxNWU","h2":"best_sellers_h2__jOLyc","best_sellers_main":"best_sellers_best_sellers_main__VgAdo","best_sellers_card":"best_sellers_best_sellers_card__OUO1u","bg_best":"best_sellers_bg_best__MqF5R","best_sellers_wishlist":"best_sellers_best_sellers_wishlist__qGRnk","add_to_card":"best_sellers_add_to_card__s5zin","btn_get_started":"best_sellers_btn_get_started__M8LSw","product_text_d":"best_sellers_product_text_d__7_7Sr","best_ss_p":"best_sellers_best_ss_p__puG80"};

/***/ }),

/***/ 22828:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"snowflakes":"homeloader_snowflakes__V3kk9","fade-out":"homeloader_fade-out__iia77","homepage_diamond_rain":"homeloader_homepage_diamond_rain__qgY8b","snowflake":"homeloader_snowflake__n4zdx","snowflakes-fall":"homeloader_snowflakes-fall__Ru3rC","snowflakes-shake":"homeloader_snowflakes-shake__KzfH2","diwali_wrapper":"homeloader_diwali_wrapper__7FFXy","canvas":"homeloader_canvas__UPJ0G","container21":"homeloader_container21__ODOaD","diya":"homeloader_diya__rZcxc","diyas":"homeloader_diyas__YW1eX","diyasx":"homeloader_diyasx__SaRTg","fall":"homeloader_fall___b0FB","animate":"homeloader_animate__3i2cZ"};

/***/ }),

/***/ 70478:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mobile_banner_slide":"mobile_banner_mobile_banner_slide__MYIDq","banner_images":"mobile_banner_banner_images__I4keI"};

/***/ }),

/***/ 73665:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"best_sellers":"mobile_best_sellers_best_sellers__XM9mm","best_sellersheader":"mobile_best_sellers_best_sellersheader__YBrpJ","h2":"mobile_best_sellers_h2___Rosv","jwellery":"mobile_best_sellers_jwellery__rMvXi","best_sellers_main":"mobile_best_sellers_best_sellers_main__DiU7K","best_sellers_card":"mobile_best_sellers_best_sellers_card__bEhcq","best_sellers_wishlist":"mobile_best_sellers_best_sellers_wishlist__ocWdT","add_to_card":"mobile_best_sellers_add_to_card__Xe0sO","btn_get_started":"mobile_best_sellers_btn_get_started__Md3TW","best_ss_p":"mobile_best_sellers_best_ss_p__kJ5qx"};

/***/ }),

/***/ 88819:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"collection":"mobile_collection_collection__frcxP","collectionheader":"mobile_collection_collectionheader__S612M","collection_slide_item":"mobile_collection_collection_slide_item__dapYN","slide_img":"mobile_collection_slide_img__TxpgH","port_text":"mobile_collection_port_text__xrVId","h3_sub":"mobile_collection_h3_sub__bMUuY","port_btn":"mobile_collection_port_btn__vilfm","collection_image":"mobile_collection_collection_image__5t52E","slick-prev":"mobile_collection_slick-prev__hSg6u"};

/***/ }),

/***/ 16300:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"lustcollection":"mobile_lustcollection_lustcollection__mtFG5","play_icon_section":"mobile_lustcollection_play_icon_section___6dYc","play_icon1":"mobile_lustcollection_play_icon1__LJWGz","btn_get_started":"mobile_lustcollection_btn_get_started__4Atb_","videoResponsive":"mobile_lustcollection_videoResponsive__aFo9Q"};

/***/ }),

/***/ 25714:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"new_arrivals":"mobile_new_arrivals_new_arrivals__mdGDz","new_arrivalsheader":"mobile_new_arrivals_new_arrivalsheader__V_V4i","jwellery":"mobile_new_arrivals_jwellery__idps1","text":"mobile_new_arrivals_text__ivVoL","new_arrivals_main":"mobile_new_arrivals_new_arrivals_main__U_adv","new_arrivals_card":"mobile_new_arrivals_new_arrivals_card__HDEW_","new_arrivals_wishlist":"mobile_new_arrivals_new_arrivals_wishlist__L4U_p","add_to_card":"mobile_new_arrivals_add_to_card__741bu","btn_get_started":"mobile_new_arrivals_btn_get_started__XbVFB","best_ss_p":"mobile_new_arrivals_best_ss_p__EX64Q","text_p":"mobile_new_arrivals_text_p__RfKyC","card_new":"mobile_new_arrivals_card_new__Qzb7o","product_image":"mobile_new_arrivals_product_image__4DYRX"};

/***/ }),

/***/ 8639:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"perfect_gift":"mobile_perfect_gift_perfect_gift__6bh_x","perfect_gift_header":"mobile_perfect_gift_perfect_gift_header__HD3nK","col_11":"mobile_perfect_gift_col_11__j4G4H","gift_jwellery":"mobile_perfect_gift_gift_jwellery__5RSTU","gift_text":"mobile_perfect_gift_gift_text__RtRIA","h3_sub":"mobile_perfect_gift_h3_sub__uVbEh","btn_get_started":"mobile_perfect_gift_btn_get_started__YYCnh","offer":"mobile_perfect_gift_offer__viXyF"};

/***/ }),

/***/ 22073:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"senco_exclusive":"mobile_senco_exclusive_senco_exclusive__nxViB","senco_exclusive_header":"mobile_senco_exclusive_senco_exclusive_header__Bvi5_","senco_exclusive_header_text":"mobile_senco_exclusive_senco_exclusive_header_text__cw59h","senco_exclusive_main":"mobile_senco_exclusive_senco_exclusive_main__HUh4I","senco_exclusive_card":"mobile_senco_exclusive_senco_exclusive_card__DnfMu","senco_exclusive_links":"mobile_senco_exclusive_senco_exclusive_links__uKrbr","btn_get_started":"mobile_senco_exclusive_btn_get_started__O8lNl","btn_get_started1":"mobile_senco_exclusive_btn_get_started1__xFAXF"};

/***/ }),

/***/ 3670:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sencostory":"mobile_senco_story_sencostory__m7WhB","sencostory_main":"mobile_senco_story_sencostory_main__5jeDN","btn_get_started":"mobile_senco_story_btn_get_started__Qjb5R","history":"mobile_senco_story_history__ACvJ9"};

/***/ }),

/***/ 17703:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sencostory":"mobile_sencostory_sencostory__DBkJJ","sencostory_main":"mobile_sencostory_sencostory_main__DPASi","h2":"mobile_sencostory_h2__6a54h","btn_get_started":"mobile_sencostory_btn_get_started__BNeYt","history":"mobile_sencostory_history__ZAPKu","h4":"mobile_sencostory_h4__PsnY8"};

/***/ }),

/***/ 70320:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mobile_shop_by_category":"mobile_shop_by_category_mobile_shop_by_category__6zn5z","shopbycategoryheader_head":"mobile_shop_by_category_shopbycategoryheader_head__I8Do0","mobile_shop_by_category_slider":"mobile_shop_by_category_mobile_shop_by_category_slider__k_4E2","mobile_shop_by_category_card":"mobile_shop_by_category_mobile_shop_by_category_card__1nXWM","swiper_button_prev_1":"mobile_shop_by_category_swiper_button_prev_1__weUrk","swiper_button_next_1":"mobile_shop_by_category_swiper_button_next_1__Dg_sf","icon_color":"mobile_shop_by_category_icon_color__fSn2W"};

/***/ }),

/***/ 2927:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mobile_shopbybudget":"mobile_shopbybudget_mobile_shopbybudget__XBuMZ","h5":"mobile_shopbybudget_h5__oxGIz","shopbybudgetheader":"mobile_shopbybudget_shopbybudgetheader___4Rd4","shopbybudgetheader_text":"mobile_shopbybudget_shopbybudgetheader_text__T8STz","row":"mobile_shopbybudget_row__uTA1Y","col_6":"mobile_shopbybudget_col_6__sgCgm"};

/***/ }),

/***/ 65014:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"subscribe_main_full":"mobile_subscribe_subscribe_main_full__NuK5G","subscribe_main":"mobile_subscribe_subscribe_main__4qlra","h4":"mobile_subscribe_h4__ZwrSg","form_input":"mobile_subscribe_form_input__qnudV","btn_get_started1":"mobile_subscribe_btn_get_started1__AyMJm"};

/***/ }),

/***/ 82409:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"trending_design":"mobile_trending_design_trending_design___crGf","trending_design_header":"mobile_trending_design_trending_design_header__4r8p5","h2":"mobile_trending_design_h2__Q0wE2","trend":"mobile_trending_design_trend__huQRr","trending_design_main":"mobile_trending_design_trending_design_main__ux3X2","trending_design_card":"mobile_trending_design_trending_design_card__2Lkr_","trending_design_wishlist":"mobile_trending_design_trending_design_wishlist__s6b5i","add_to_card":"mobile_trending_design_add_to_card__knS_Z","btn_get_started":"mobile_trending_design_btn_get_started__AAhnm"};

/***/ }),

/***/ 73303:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"vivah_collection":"mobile_vivah_collection_vivah_collection__Z1jq0","vivah_collection_header":"mobile_vivah_collection_vivah_collection_header___8kl3","vivah_collection_header_text":"mobile_vivah_collection_vivah_collection_header_text__ugEkJ","vivah_collection_main":"mobile_vivah_collection_vivah_collection_main__YADfn","vivah_collection_card":"mobile_vivah_collection_vivah_collection_card__afVCF","vivah_collection_card_1":"mobile_vivah_collection_vivah_collection_card_1__1EWEI","btn_get_started":"mobile_vivah_collection_btn_get_started__wvvBH","videoResponsive":"mobile_vivah_collection_videoResponsive__bvx0m"};

/***/ }),

/***/ 20337:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"with_every_product":"mobile_with_every_product_with_every_product__kYtEV","col_14":"mobile_with_every_product_col_14__u30sw"};

/***/ }),

/***/ 2954:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"senco_exclusive":"senco_exclusive_senco_exclusive__ZvAuk","senco_exclusive_header":"senco_exclusive_senco_exclusive_header__9eoh_","senco_exclusive_header_text":"senco_exclusive_senco_exclusive_header_text__aLbt0","senco_exclusive_main":"senco_exclusive_senco_exclusive_main__LQkD6","senco_exclusive_card":"senco_exclusive_senco_exclusive_card__uFJV1","senco_exclusive_links":"senco_exclusive_senco_exclusive_links__H303f","btn_get_started":"senco_exclusive_btn_get_started__SizNL","btn_get_started1":"senco_exclusive_btn_get_started1__HBKud"};

/***/ }),

/***/ 51317:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"banner_main_slide":"slider_banner_main_slide__F_xqW","swiper-pagination":"slider_swiper-pagination__Lh4mq","swiper-dotted":"slider_swiper-dotted__k0b2Z","swiper-pagination-bullet":"slider_swiper-pagination-bullet__1HYL7"};

/***/ }),

/***/ 31637:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"subscribe_main":"subscribe_subscribe_main__ea9yI","h4":"subscribe_h4__8V_bl","form_input":"subscribe_form_input__mF8cH","btn_get_started1":"subscribe_btn_get_started1__h1JcW"};

/***/ }),

/***/ 80739:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"vivah_collection":"vivah_collection_vivah_collection__BZ0m5","vivah_collection_header":"vivah_collection_vivah_collection_header__btbvR","vivah_collection_header_text":"vivah_collection_vivah_collection_header_text__7ggR1","vivah_collection_main":"vivah_collection_vivah_collection_main__G1xjQ","vivah_collection_card":"vivah_collection_vivah_collection_card__r_zQr","vivah_collection_card_1":"vivah_collection_vivah_collection_card_1__82VmE","btn_get_started":"vivah_collection_btn_get_started__o8ZfX","videoResponsive":"vivah_collection_videoResponsive__jPEdS"};

/***/ }),

/***/ 11329:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"with_every_product":"with_every_product_with_every_product__b9hAP","h2":"with_every_product_h2__Tk4_E","col_14":"with_every_product_col_14__pvwmU"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8523,4766,959,1387,9082,1246,1879,3564,3278,4071,1740,5314,2295,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);